import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/var/lib/jenkins/jobs/app-styleguide/workspace/src/templates/page.js"
import { Uploader } from 'module-tsl-ui-uploader';
import WithDocgen from 'module-tsl-ui-uploader/with-docs/Uploader';
import pkg from 'module-tsl-ui-uploader/package.json';
import PropsTable from '../../../components/propsTable';
import Version from '../../../components/version';
import LiveCode from '../../../components/liveCode';

const layoutProps = {
  
};
export default class MDXContent extends React.Component {
  constructor(props) {
    super(props)
    this.layout = DefaultLayout
  }
  render() {
    const { components, ...props } = this.props

    return <MDXTag
             name="wrapper"
             Layout={this.layout} layoutProps={Object.assign({}, layoutProps, props)}
             components={components}>


<MDXTag name="h3" components={components} props={{"id":"example-editable"}}><MDXTag name="a" components={components} parentName="h3" props={{"href":"#example-editable","aria-label":"example editable permalink","class":"anchor"}}></MDXTag>{`example (editable)`}</MDXTag>
<LiveCode
  code={`<div style={{ width: 600 }}>
  <Uploader
    label="Supporting Documents"
    info={
      <ul>
        <li>Callback function is called on adding, editing, removing files.</li>
        <li>Accepted files are logged in the console for checking now.</li>
        <li>Also has a getFiles() function that can be called through reference.</li>
      </ul>
    }
    ctaText={
      <span>
        Drag and drop your supporting
        <br />
        documents here
      </span>
    }
    callback={files => console.log(files)}
    onAdd={files => console.log(files)}
    onUpdate={file => console.log(file)}
    onDelete={file => console.log(file)}
    onPrint={file => console.log(file)}
    onDownload={(file, event) => console.log(file, event)}
    multiple
    types={['Person specification', 'Applicant information pack', 'Other documents']}
    files={[
      {
        isAmenable: false,
        isPrintable: true,
        name: 'First file.pdf',
        downloadUrl: 'https://google.com',
        customOptions: <div className="tds-file-option tds-no-select">Preview file</div>,
      },
      {
        accepted: false,
        name: 'Another file.wat',
        type: 'Applicant information pack',
      },
      {
        accepted: true,
        name: 'Fake Filename And Extension.jpg',
        type: 'Applicant information pack',
      },
      {
        accepted: true,
        name: 'Filename without extension',
        info: 'We are unable to preview this type of file, please download it',
      },
    ]}
  />
</div>
`}
  scope={ { Uploader } }
/>
<PropsTable data={WithDocgen.__docgenInfo} />
<Version name={'npm i module-tsl-ui-uploader --save'} version={pkg.version} />
           </MDXTag>
  }
}

export const _frontmatter = {};

  